import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FormValidator from "../../utils/FormValidator"
import NotificationHandler from "../../utils/NotificationHandler"
import { enumUtil } from "../../utils/Enum"
import { ServerRequestProtected } from "../../utils/ServerDataRequest"
import Loader from "../shared/Loader/Loader"

const ResetPassword = (props) => {
    const API_URL = enumUtil.controller.Login

    let navigate = useNavigate()
    const dispatch = useDispatch();
    const year = new Date().getFullYear();

    let ForgotPassword_Modal = {
        Email: "",
    }
    let valModal = {}
    let ValidationModal = {
        EmailVal: "",
        Email: "",
    }
    const [isLoading, setIsLoading] = useState(false)
    const [mainForgotPasswordModal, setmainForgotPasswordModal] = useState(ForgotPassword_Modal);
    const [ForgotPasswordSaveUpdateModal, setForgotPasswordSaveUpdateModal] = useState({});
    const [ForgotPasswordValidationModal, setForgotPasswordValidationModal] = useState(ValidationModal)
    const [hide, setHide] = useState(false);
    const handleForgotPasswordChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainForgotPasswordModal };
        let saveModal = { ...ForgotPasswordSaveUpdateModal }
        modal[name] = value
        setmainForgotPasswordModal(modal)
        for (var property in ForgotPassword_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setForgotPasswordSaveUpdateModal(saveModal)
    }
    const ForgotPasswordValidation = async () => {
        let ValidationModal = {
            EmailVal: FormValidator(
                mainForgotPasswordModal.Email,
                enumUtil.enumValidationType.Required,
                'Email',
            ),
            Email: FormValidator(
                mainForgotPasswordModal.Email,
                enumUtil.enumValidationType.Email,
                'Email',
            ),
        }
        await setForgotPasswordValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSubmit = async (event) => {
        await ForgotPasswordValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            // NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setIsLoading(true);
            ServerRequestProtected(API_URL + "/ForgotPassword", 'post',
                {
                    ...ForgotPasswordSaveUpdateModal
                }
            ).then((response) => {
                setIsLoading(false)
                event.preventDefault();
                NotificationHandler('Email Sent Successfully', enumUtil.enumtoaster.success)
                navigate("../checkemail", {
                    state: { ...ForgotPasswordSaveUpdateModal }
                })
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler("Invalid email address, please enter valid email. ", enumUtil.enumtoaster.error)
            })
        }
    }
        const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <React.Fragment >
            {/* {isLoading ? <Loader /> : null} */}
            {/* <div className="login">
                <div className="d-lg-flex half overflow-hidden">
                    <div className="bg order-1 order-md-2">
                        <img src={process.env.PUBLIC_URL + "/assets/images/v2LoginHMS.jpg"} alt="" />
                    </div>
                    <div className="contents order-2 order-md-1">


                        <div className="container hk-form-t">
                            <div className="row align-items-center justify-content-center">
                                <div className="col-md-10 d-flex flex-column justify-content-center">
                                    <div className="hk-t-img mb-25">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/lock-password.png"} alt="forget password icon" />
                                    </div>
                                    <p className="text clr-muted text-center mt-3 forget-p">No worries, we’ll send you reset notifications.</p>

                                    <div className="mt-12">
                                        <div className={ForgotPasswordValidationModal.EmailVal ? "form-group input error" : " form-group input"}>
                                            <div className={ForgotPasswordValidationModal.Email ? "form-group input error" : " form-group input"}>
                                                <input type="text"
                                                    placeholder="Enter Your Email"
                                                    className="form-control forget-input"
                                                    maxLength={50}
                                                    name="Email"
                                                    id="Email"
                                                    value={mainForgotPasswordModal.Email}
                                                    onChange={handleForgotPasswordChange}

                                                />
                                                {ForgotPasswordValidationModal.EmailVal}
                                                {ForgotPasswordValidationModal.Email}
                                            </div>
                                        </div>
                                        <input type="submit" value="Reset password" className="btn rounded btn-greenn w-100" onClick={handleSubmit} />
                                    </div>
                                    <a className="text text-center inst-txt mt-4 text-decoration-none" onClick={() => navigate("../", { replace: true })}><span class="icon-Icon-ionic-md-arrow-round-back"></span> Back to Login</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}


            <div className="ar_login-screen">
                <div className="ar-main-screen-content w-100 d-flex align-items-center flex-column gap-25 justify-content-center">
                    <div className="login-content">
                        <div className="img-container h-auto s-70 mx-auto mb-15">
                            <img src={process.env.PUBLIC_URL + "/assets/images/lock-password.png"} alt="" />
                        </div>
                        <div className="mb-2 d-flex flex-column align-items-center">
                            <p className='fs-20 heading lh-normal'>Forget Password?</p>
                            <p className='text fs-11 color-muted lh-normal'>No worries, we’ll send you reset notification</p>
                        </div>
                            <div className="d-flex flex-column gap-20 br-bottom-1 za_br_light pb-4 mb-4">
                                <div className={ForgotPasswordValidationModal.EmailVal ? "form-group input error mb-0" : " form-group input mb-0"}>
                                    <div className={ForgotPasswordValidationModal.Email ? "form-group input error mb-0" : " form-group input mb-0"}>
                                        <label htmlFor="">Email</label>
                                        <input type="text"
                                            className="form-control forget-input"
                                            maxLength={50}
                                            name="Email"
                                            id="Email"
                                            value={mainForgotPasswordModal.Email}
                                            onChange={handleForgotPasswordChange}
                                        />
                                        {ForgotPasswordValidationModal.EmailVal}
                                        {ForgotPasswordValidationModal.Email}
                                    </div>
                                </div>
                                <div className='position-relative login-btn-loader'>
                                    <input type="submit" value={`${isLoading === true ? '' : 'Reset password'}`} className="btn rounded btn-orange heading w-100" onClick={handleSubmit} />

                                    {isLoading === true ?
                                        <div className='last_loader ar-small-loader'>
                                            <div className="circle circle1"></div>
                                            <div className="circle circle2"></div>
                                        </div> :
                                        null}
                                </div>

                                <a className="text text-center inst-txt text-decoration-none" onClick={() => navigate("../", { replace: true })}><span class="icon-Icon-ionic-md-arrow-round-back fs-9"></span> Back to Login</a>
                            </div>

                            <div className="d-flex align-items-center justify-content-center">
                                <p className='text fs-12 color-95 '>©{year} {ThemeConfiguration?.configuration?.company?.name}. All rights reserved</p>
                            </div>
                    </div>
                </div>
            </div>

            {/* Two-Factor Authentication  1st Screen    */}

            {/* <div className="ar_login-screen">
                <div className="ar-main-screen-content w-100 d-flex align-items-center flex-column gap-25 justify-content-center">
                    <div className="login-content">
                        <div className="d-flex flex-column align-items-center mb-4 pb-1-5">
                            <p className='fs-20 heading lh-normal'>Two-Factor Authentication</p>
                            <p className='text fs-11 color-muted lh-normal'>Select how you want to receive OTP to verify your account.</p>
                        </div>
                        <div className="d-flex flex-column gap-20 br-bottom-1 za_br_light pb-4 mb-4">
                            <div className="">
                                <p className="text fs-14 mb-2">Please select 2FA verification method:</p>
                                <label className="d-flex align-items-center gap-6">
                                    <input
                                        type="radio"
                                        id="CardView"
                                        checked
                                    />
                                    <p className="heading fs-13" htmlFor="CPT">Email Address: i************@g*****.com</p>
                                </label>
                            </div>
                            <div className='position-relative login-btn-loader'>
                                <input type="submit" value={`${isLoading === true ? '' : 'Continue'}`} className="btn rounded btn-orange heading w-100" onClick={handleSubmit} />

                                {isLoading === true ?
                                    <div className='last_loader ar-small-loader'>
                                        <div className="circle circle1"></div>
                                        <div className="circle circle2"></div>
                                    </div> :
                                    null}
                            </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-center">
                            <p className='text fs-12 color-95 '>©2025 Star Healthcare Technologies. All rights reserved</p>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* Two-Factor Authentication  2st Screen    */}

            {/* <div className="ar_login-screen">
                <div className="ar-main-screen-content w-100 d-flex align-items-center flex-column gap-25 justify-content-center">
                    <div className="login-content">
                        <div className="d-flex flex-column align-items-center mb-10 text-center">
                            <p className='fs-20 heading lh-normal'>Two-Factor Authentication</p>
                            <p className='text fs-11 color-muted lh-normal'>An email with OTP has been sent to <br /> i************@gmail.com.</p>
                        </div>
                        <div className="d-flex flex-column gap-20 br-bottom-1 za_br_light pb-4 mb-4">
                            <div className="mt-2">
                                <div className="d-flex align-items-center gap-12 justify-content-center py-1 mb-4 input-for-authantication">
                                    <div className="input w-41px ">
                                        <input
                                            type='number'
                                            className='form-control fs-17 text-black text-center'
                                        />
                                    </div>
                                    <div className="input w-41px">
                                        <input
                                            type='number'
                                            className='form-control fs-17 text-black text-center'
                                        />
                                    </div>
                                    <div className="input w-41px">
                                        <input
                                            type='number'
                                            className='form-control fs-17 text-black text-center'
                                        />
                                    </div>
                                    <div className="input w-41px">
                                        <input
                                            type='number'
                                            className='form-control fs-17 text-black text-center'
                                        />
                                    </div>
                                    <div className="input w-41px">
                                        <input
                                            type='number'
                                            className='form-control fs-17 text-black text-center'
                                        />
                                    </div>
                                    <div className="input w-41px">
                                        <input
                                            type='number'
                                            className='form-control fs-17 text-black text-center'
                                        />
                                    </div>
                                </div>
                                <p className="text fs-14 text-center">Didn’t receive a code or need a new one? <span className="heading ar-dark-color cursor-pointer fs-14">Resend</span></p>
                            </div>
                            <div className='position-relative login-btn-loader'>
                                <input type="submit" value={`${isLoading === true ? '' : 'Continue'}`} className="btn rounded btn-orange heading w-100" onClick={handleSubmit} />

                                {isLoading === true ?
                                    <div className='last_loader ar-small-loader'>
                                        <div className="circle circle1"></div>
                                        <div className="circle circle2"></div>
                                    </div> :
                                    null}
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                            <p className='text fs-12 color-95 '>©2025 Star Healthcare Technologies. All rights reserved</p>
                        </div>
                    </div>
                </div>
            </div> */}

        </React.Fragment >
    )
}
export default ResetPassword